module.exports = __webpack_public_path__ + "img/inventory_frame.9dbf952f.png";